import { useAnonRestApi, useAuthRestApi } from '../common';
import { Observable, of } from 'rxjs';
import { IExternalMenuItem, IVivliConfiguration, IVivliConfigurationApi } from '@vivli/shared/infrastructure/interface';
import { environment } from '@vivli/core/environments';
import { intercepts } from '@vivli/shared/intercepts';

export const useVivliConfigApi = (): IVivliConfigurationApi => {
    const { handleGet } = useAuthRestApi();
    const anonRestApi = useAnonRestApi();

    const getVivliConfig = (): Observable<IVivliConfiguration> => {
        if (environment.useIntercepts) {
            return of(intercepts.vivliConfig);
        }

        return handleGet<IVivliConfiguration>('/vivliConfig');
    };

    const getExternalMenuItems = (): Observable<IExternalMenuItem[]> => {
        return anonRestApi.handleGet<IExternalMenuItem[]>('/vivliConfig/externalMenuItems');
    };

    return {
        getVivliConfig,
        getExternalMenuItems
    };
};
